import React from "react";
import styles from "./ChildrenRequirementLayout.module.css";
import { DeliverablesList } from "../../../../../../../../../common/components";

export default function ChildrenRequirementLayout({ reqId }) {
	return (
		<div className={styles.container}>
			<div className={styles.deliverablesListContainer}>
				<DeliverablesList reqId={reqId} />
			</div>
		</div>
	);
}
